import { FC, useCallback, useContext, useEffect, useState } from 'react';
import LoaderImage from '@assets/loader.gif';
import Table from '@components/Table';
import ColumnChart from '@components/Charts/ColumnChart';
/*import LineChart from '@components/Charts/LineChart';*/
import TreemapChart from '@components/Charts/TreemapChart';
import FooterChart from '@components/Charts/FooterChart';
import ClusteredColumnChart from '@components/Charts/ClusteredColumnChart';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import UnemployedDrillDownTable from '@components/UnemployedDrillDownTable';
import BoltIcon from '@mui/icons-material/Bolt';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import SortIcon from '@mui/icons-material/Sort';
import BarChartIcon from '@mui/icons-material/BarChart';
import { OccupationsContext } from '@providers/Occupations';
import { LabourDemandPulseContext } from '@providers/LabourDemandPulse';
import TopSkills from "@components/CountryDetails/components/TopSkills";
import Button from '@components/Button';
import ExportButton from '@components/ExportButton';
import * as types from '@models/types';
import * as url from '@api/requests';
import { SkillTypes, WSSkillGroups } from '@helpers/enums';
import './LabourDemandPulseTab.scss';

type LabourDemandPulseTabProps = {
    countryData: types.CountryDataTypes;
    isLoading: number;
    handleClick: (a: any) => void;
    selectedProfile: types.SelectedProfileTypes;
};

const topEmployersTableCols = [
    {
        key: 'employer',
        label: 'Employer',
    },
    {
        key: 'sectorName',
        label: 'Sector',
    },
    {
        key: 'jobCount',
        label: 'Number of job posts',
    },
    {
        key: 'percentage',
        label: 'Market share',
    },
]


const LabourDemandPulseTab: FC<LabourDemandPulseTabProps> = ({
    countryData,
    isLoading,
    handleClick,
    selectedProfile
}) => {
    const { yearlyOccupationTrend, topSkills } = useContext(OccupationsContext); // eslint-disable-line
    const { topEmployersByQuarter, treeMapInfo, topSectorsAndOccupationsYearOnYear, unemployedJobPosts } = useContext(LabourDemandPulseContext);// eslint-disable-line
    const [topSkillGroup, setTopSkillGroup] = useState<string>(WSSkillGroups.HardSkill);
    const [skillType, setSkillType] = useState<string>(SkillTypes.ESCO);
    const [showUnemployedBarChart, setShowUnemployedBarChart] = useState<boolean>(true);

    // Reset states on tab change
    useEffect(() => {
        setShowUnemployedBarChart(true);
    }, []);

    const handleChangeSkillType = useCallback(() => {
        setSkillType((prevSkillsType: string) => (prevSkillsType === SkillTypes.WS ? SkillTypes.ESCO : SkillTypes.WS));
    }, []);

    return <div className="occupation-tab">
        {isLoading > 0 ? <div className="row mb-3">
            <div className="col-5">
                <div className="widget-component">
                    <h4 className="border-bottom mb-2 pb-2">Top employers in {countryData.country}</h4>
                    {topEmployersByQuarter && topEmployersByQuarter.length ?
                        <div>
                            <ExportButton countryName={countryData.country} exportDOMId="topEmployers" urlAPI={url.exportTopEmployersByQuarter} urlDataAPI={{ 
                                hubIds: [countryData.hubId], 
                                locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [], 
                                fromTimeline: selectedProfile.fromTimeline?.title, 
                                toTimeline: selectedProfile.toTimeline?.title,
                                isEntryLevel: selectedProfile.isEntryLevel
                            }} 
                            />
                            <Table id="topEmployers" columns={topEmployersTableCols} data={topEmployersByQuarter.map(e => {
                                e.percentage = (e.percentage && typeof (e.percentage) === "number") ? e.percentage.toFixed(1) + "%" : e.percentage;
                                return e;
                            })} />
                        </div>
                        :
                        <div className="na">N/A</div>
                    }
                </div>
            </div>
            <div className="col-7">
                {/*<div className="widget-component">*/}
                    {/*<h4 className="border-bottom mb-2 pb-2">Historic job posts</h4>*/}
                    {/*{yearlyOccupationTrend && yearlyOccupationTrend.length ? */}
                    {/*    <div>*/}
                    {/*        <ExportButton countryName={countryData.country} exportDOMId="historicalJobs-chart-container" urlAPI={url.exportYearlyOccupationTrend} urlDataAPI={{*/}
                    {/*            hubIds: [countryData.hubId],*/}
                    {/*            sectorIds: selectedProfile.sector.length ? selectedProfile.sector.map((e: any) => e.id) : [],*/}
                    {/*            occupationCategoryIds: selectedProfile.occupation.length ? selectedProfile.occupation.map((e: any) => e.id) : [],*/}
                    {/*            locations: selectedProfile.provinces.length ? selectedProfile.provinces.map((e: any) => e.title) : [],*/}
                    {/*            year: null,*/}
                    {/*            yearlyPercentSentence: null,*/}
                    {/*            isEntryLevel: selectedProfile.isEntryLevel*/}
                    {/*        }}*/}
                    {/*        />*/}
                    {/*        <div id="historicalJobs-chart-container">*/}
                    {/*            <LineChart name="historicalJobs" data={yearlyOccupationTrend} xLabels={{ rotation: -20 }} titleY="Number of job posts" selectedQuarter={{ from: selectedProfile.fromTimeline?.title, to: selectedProfile.toTimeline?.title }} />*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    {/*    <div className="na">N/A</div>*/}
                    {/*}*/}
                {/*</div>*/}
            </div>


        </div> : null}

        {isLoading > 1 ? <div className="col-sm-12">
            <div className="widget-component">
                <h4 className="border-bottom mb-2 pb-2">Treemap</h4>
                {treeMapInfo && ((treeMapInfo.sectors && treeMapInfo.sectors.length) || (treeMapInfo.occupations && treeMapInfo.occupations.length)) ?
                    <>
                        {treeMapInfo.sectors.length ?
                            <div className="mb-3">
                                <ExportButton countryName={countryData.country} exportDOMId="Sector-treemapChart" urlAPI={url.exportTreeMapInfo} urlDataAPI={{
                                    type: "Sector",
                                    hubIds: [countryData.hubId],
                                    locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [],
                                    fromTimeline: selectedProfile.fromTimeline?.title,
                                    toTimeline: selectedProfile.toTimeline?.title,
                                    isEntryLevel: selectedProfile.isEntryLevel
                                }}
                                />
                                <TreemapChart name="Sector" data={treeMapInfo.sectors} handleClick={handleClick} />
                            </div> : null
                        }
                        {treeMapInfo.occupations.length ?
                            <div className="mb-3">
                                <ExportButton countryName={countryData.country} exportDOMId="Occupation-treemapChart" urlAPI={url.exportTreeMapInfo} urlDataAPI={{
                                    type: "Occupation",
                                    hubIds: [countryData.hubId],
                                    locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [],
                                    fromTimeline: selectedProfile.fromTimeline?.title,
                                    toTimeline: selectedProfile.toTimeline?.title,
                                    isEntryLevel: selectedProfile.isEntryLevel
                                }}
                                />
                                <TreemapChart name="Occupation" data={treeMapInfo.occupations} handleClick={handleClick} />
                            </div> : null
                        }
                    </>
                    : <div className="na">N/A</div>}
            </div>
        </div>
            : null
        }

        {/*{isLoading > 2 ? <>*/}
        {/*    <div className="mb-3">*/}
        {/*        <div className="widget-component">*/}
        {/*            <h4 className="border-bottom mb-2 pb-2">Fastest growing sectors (year on year)​ <i className="noteSize">Note:(To access the year-on-year indicators, please ensure that the initial year's data is available.)</i></h4>*/}
        {/*            {topSectorsAndOccupationsYearOnYear && topSectorsAndOccupationsYearOnYear.sectors && topSectorsAndOccupationsYearOnYear.sectors.length > 0 ?*/}
        {/*                <div>*/}
        {/*                    <ExportButton countryName={countryData.country} exportDOMId="sectors-chart" urlAPI={url.exportTopSectorsAndOccupationsYearOnYear} urlDataAPI={{*/}
        {/*                        hubIds: [countryData.hubId],*/}
        {/*                        locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [],*/}
        {/*                        timeline: selectedProfile.fromTimeline?.title,*/}
        {/*                        type: "Sector",*/}
        {/*                        isEntryLevel: selectedProfile.isEntryLevel*/}
        {/*                    }}*/}
        {/*                    />*/}
        {/*                    <div id="sectors-chart">*/}
        {/*                        <ColumnChart name="sectors" data={topSectorsAndOccupationsYearOnYear.sectors} titleX="Top sectors " titleY="Percentage change​" percentY={true} />*/}
        {/*                    </div>*/}
        {/*                </div>*/}
        {/*                :*/}
        {/*                <div className="na">N/A</div>*/}
        {/*            }*/}
        {/*        </div>*/}
        {/*    </div>*/}

        {/*    <div className="mb-3">*/}
        {/*        <div className="widget-component">*/}
        {/*            <h4 className="border-bottom mb-2 pb-2">Fastest growing ISCO2 occupations (year on year)​ <i className="noteSize">Note:(To access the year-on-year indicators, please ensure that the initial year's data is available.)</i></h4>*/}
        {/*            {topSectorsAndOccupationsYearOnYear && topSectorsAndOccupationsYearOnYear.isco2_occupations && topSectorsAndOccupationsYearOnYear.isco2_occupations.length > 0 ?*/}
        {/*                <div>*/}
        {/*                    <ExportButton countryName={countryData.country} exportDOMId="isco2-occupations-chart" urlAPI={url.exportTopSectorsAndOccupationsYearOnYear} urlDataAPI={{*/}
        {/*                        hubIds: [countryData.hubId],*/}
        {/*                        locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [],*/}
        {/*                        timeline: selectedProfile.fromTimeline?.title,*/}
        {/*                        type: "ISCO2Occupation",*/}
        {/*                        isEntryLevel: selectedProfile.isEntryLevel*/}
        {/*                    }}*/}
        {/*                    />*/}
        {/*                    <div id="isco2-occupations-chart">*/}
        {/*                        <ColumnChart name="isco2-occupations" data={topSectorsAndOccupationsYearOnYear.isco2_occupations} titleX="Top ISCO2 occupations" titleY="Percentage change​" percentY={true} />*/}
        {/*                    </div>*/}
        {/*                </div>*/}
        {/*                :*/}
        {/*                <div className="na">N/A</div>*/}
        {/*            }*/}
        {/*        </div>*/}
        {/*    </div>*/}

        {/*    <div className="mb-3">*/}
        {/*        <div className="widget-component">*/}
        {/*            <h4 className="border-bottom mb-2 pb-2">Fastest growing ISCO4 occupations (year on year)​ <i className="noteSize">Note:(To access the year-on-year indicators, please ensure that the initial year's data is available.)</i></h4>*/}
        {/*            {topSectorsAndOccupationsYearOnYear && topSectorsAndOccupationsYearOnYear.isco4_occupations && topSectorsAndOccupationsYearOnYear.isco4_occupations.length > 0 ?*/}
        {/*                <div>*/}
        {/*                    <ExportButton countryName={countryData.country} exportDOMId="isco4-occupations-chart" urlAPI={url.exportTopSectorsAndOccupationsYearOnYear} urlDataAPI={{*/}
        {/*                        hubIds: [countryData.hubId],*/}
        {/*                        locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [],*/}
        {/*                        timeline: selectedProfile.fromTimeline?.title,*/}
        {/*                        type: "ISCO4Occupation",*/}
        {/*                        isEntryLevel: selectedProfile.isEntryLevel*/}
        {/*                    }}*/}
        {/*                    />*/}
        {/*                    <div id="isco4-occupations-chart">*/}
        {/*                        <ColumnChart name="isco4-occupations" data={topSectorsAndOccupationsYearOnYear.isco4_occupations} titleX="Top ISCO4 occupations" titleY="Percentage change​" percentY={true} />*/}
        {/*                    </div>*/}
        {/*                </div>*/}
        {/*                :*/}
        {/*                <div className="na">N/A</div>*/}
        {/*            }*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</>*/}
        {/*    : null*/}
        {/*}*/}

        {isLoading > 3 ? <div className="occupation-tab__unemployed_job_posts mb-3">
            <div className="widget-component">
                <h4 className="border-bottom mb-2 pb-2">
                    Unemployed Job Posts
                    {showUnemployedBarChart
                        ?
                        <SortIcon className="bar-toggle-icon" onClick={() => setShowUnemployedBarChart(false)} />
                        :
                        <BarChartIcon className="bar-toggle-icon" onClick={() => setShowUnemployedBarChart(true)} />
                    }
                </h4>
                {unemployedJobPosts && unemployedJobPosts.jobs_unemployed && unemployedJobPosts.jobs_unemployed.length ?
                    <>
                        <div>
                            <ExportButton countryName={countryData.country} exportDOMId="unemployedJobPosts-graph" urlAPI={url.exportTopUnemployedJobPosts} urlDataAPI={{
                                hubIds: [countryData.hubId]
                            }} />
                            <div id="unemployedJobPosts-graph">
                                {showUnemployedBarChart ?
                                    <>
                                        <ClusteredColumnChart chartName="unemployedJobPosts" columnName="isced4_label" data={unemployedJobPosts.jobs_unemployed.slice(0, 5)} columnsSettings={[{ label: "Job Posts", fieldName: "count_jobs" }, { label: "Unemployed People", fieldName: "count_unemployed_people" }]} titleX="Specialization" titleY="Number of job posts and unemployed people​​" hideAxisX height={350} />
                                        <FooterChart axisName="Specializations" columnNames={unemployedJobPosts.jobs_unemployed.slice(0, 5).map((value: types.JobsUnemployedTypes) => { return value.isced4_label })} />
                                    </>
                                    :
                                    <UnemployedDrillDownTable data={unemployedJobPosts} />
                                }
                            </div>
                        </div>
                    </>
                    : <div className="na">N/A</div>
                }
            </div>
        </div> : null}

        {/* SKILS */}
        {isLoading > 4 ? <div className="occupation-tab__top-skills mb-3">
            <div className="widget-component">
                <h4 className="border-bottom mb-2 pb-2 occupation-tab__top-skills--header">
                    {skillType === SkillTypes.WS ?
                        <span>Top {topSkillGroup + "s"} in {countryData.country}</span>
                        :
                        <span>Top Skills in {countryData.country}</span>
                    }
                    {process.env.REACT_APP_ESCO_ENABLED === "true" &&
                        <Button label={skillType === SkillTypes.WS ? SkillTypes.ESCO : SkillTypes.WS} onClick={handleChangeSkillType} style={{ display: 'none' }} />
                    }
                </h4>
                {topSkills && topSkills.length ?
                    <div>
                        <div>
                            {skillType === SkillTypes.WS ?
                                <>
                                    <HistoryEduIcon className="bar-toggle-icon" id="topSkillsCertification-toggle" onClick={() => setTopSkillGroup(WSSkillGroups.Certification)} />
                                    <AutoFixHighIcon className="bar-toggle-icon" id="topSkillsSoftSkill-toggle" onClick={() => setTopSkillGroup(WSSkillGroups.SoftSkill)} />
                                    <BoltIcon className="bar-toggle-icon" id="topSkillsHardSkill-toggle" onClick={() => setTopSkillGroup(WSSkillGroups.HardSkill)} />
                                </>
                                :
                                <div className="d-flex justify-content-center mt-2">

                                </div>
                            }
                        </div>
                        <ExportButton countryName={countryData.country} exportDOMId="topSkills" urlAPI={url.exportTopSkills} urlDataAPI={{
                            hubIds: [countryData.hubId],
                            sectorIds: selectedProfile.sector.length ? selectedProfile.sector.map((e: any) => e.id) : [],
                            occupationCategoryIds: selectedProfile.occupation.length ? selectedProfile.occupation.map((e: any) => e.id) : [],
                            locations: (selectedProfile.provinces && selectedProfile.provinces.length) ? selectedProfile.provinces.map((e: any) => e.title) : [],
                            isEntryLevel: selectedProfile.isEntryLevel,
                            type: skillType === SkillTypes.WS ? topSkillGroup : SkillTypes.ESCO,
                        }} />
                        <div id={"topSkills"} >
                            <TopSkills topSkills={topSkills.find(ts => (skillType === SkillTypes.WS ? ts.skillGroup === topSkillGroup : ts.skillGroup === SkillTypes.ESCO))?.topSkills || []} skillType={skillType} />
                        </div>
                    </div>
                    : <div className="na">N/A</div>
                }
            </div>
        </div> : null}

        {isLoading !== 5 ? <div><img src={LoaderImage} alt="" className="mx-auto d-block" style={{ width: 30 }} /></div> : null}
    </div>;
};

export default LabourDemandPulseTab;
